const util = {
  checkScript: (name, src, callback) => {
    const scriptList = document.getElementsByTagName('script');

    let script;

    for (let i = 0; i < scriptList.length; i++) {
      if (scriptList[i].src.includes(name)) {
        script = scriptList[i];
      }
    }

    if (script) {
      callback();
    } else {
      script = document.createElement('script');

      script.async = true;

      script.src = src;

      document.head.appendChild(script);

      script.onload = () => {
        callback();
      };
    }

    return script;
  },
  removeScript: (script) => {
    document.head.removeChild(script);
  },
  removeScriptName: (name) => {
    const scriptList = document.getElementsByTagName('script');

    let script;

    for (let i = 0; i < scriptList.length; i++) {
      if (scriptList[i].src.includes(name)) {
        script = scriptList[i];
      }
    }

    if (script) {
      document.head.removeChild(script);
    }
  },
  delay: (ms) => {
    return new Promise((res) => {
      const timer = setTimeout(() => {
        res();
        clearTimeout(timer);
      }, ms);
    });
  },
};

export default util;
